import { useState, useCallback } from 'react';
import { isInternalAuthMode } from '@/utils/auth-mode';

/**
 * Toggle between Auth0 and Internal auth modes
 * Sets/clears cookie and reloads page
 */
export const AuthModeToggle = () => {
  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname.includes('localhost');
  const [isInternal, setIsInternal] = useState(isInternalAuthMode());

  const toggleAuthMode = useCallback(() => {
    if (isInternal) {
      // Switch to Auth0: clear cookie and internal token
      document.cookie = 'auth_mode=; path=/; max-age=0';
      document.cookie = 'internal_access_token=; path=/; max-age=0';
    } else {
      // Switch to Internal: set cookie
      document.cookie = 'auth_mode=local; path=/; max-age=31536000'; // 1 year
    }
    setIsInternal(!isInternal);
    window.location.reload();
  }, [isInternal]);

  // Only show on localhost
  if (!isLocalhost) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2 bg-gray-800 text-white px-3 py-2 rounded-lg shadow-lg text-sm">
      <span>Internal Auth</span>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={isInternal}
          onChange={toggleAuthMode}
          className="sr-only peer"
        />
        <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-500"></div>
      </label>
    </div>
  );
};
